import type { TemplateAsset } from "./types";

export const BASE_ASSETS = {
  firetruckSirenVideo: {
    uuid: "47687633-0c92-4ef8-8ab1-e14be0b91b8a",
    key: "videos/47687633-0c92-4ef8-8ab1-e14be0b91b8a.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 1280,
    height: 720,
  } satisfies TemplateAsset,
  firetruckSirenPoster: {
    uuid: "2de5326f-403f-4515-a140-50f3fcfe7ae4",
    key: "images/2de5326f-403f-4515-a140-50f3fcfe7ae4.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1280,
    height: 720,
  } satisfies TemplateAsset,
  approvedEquipmentKit: {
    uuid: "662f476f-cd55-4053-9eee-a4798a8a3241",
    key: "images/662f476f-cd55-4053-9eee-a4798a8a3241.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1254,
    height: 1254,
  } satisfies TemplateAsset,
  packedEquipmentKit: {
    uuid: "84aecd7a-63d9-4e08-adfa-062fa630a0c4",
    key: "images/84aecd7a-63d9-4e08-adfa-062fa630a0c4.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1254,
    height: 1254,
  } satisfies TemplateAsset,
  tennisRallyVideo: {
    uuid: "1569d1d4-6868-4a91-adea-ecaae89d30cd",
    key: "videos/1569d1d4-6868-4a91-adea-ecaae89d30cd.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 1280,
    height: 716,
  } satisfies TemplateAsset,
  tennisRallyPoster: {
    uuid: "b6169059-95a0-4bda-8c45-16e92f2a9a21",
    key: "images/b6169059-95a0-4bda-8c45-16e92f2a9a21.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1280,
    height: 716,
  } satisfies TemplateAsset,
  treeDetail: {
    uuid: "6ea7fafc-53f0-4b3f-9179-01b397790f11",
    key: "images/6ea7fafc-53f0-4b3f-9179-01b397790f11.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1050,
    height: 1400,
  } satisfies TemplateAsset,
  shapes: {
    uuid: "5a2f1a18-3c74-4a84-9c3b-2b8e4f8d9c91",
    key: "images/5a2f1a18-3c74-4a84-9c3b-2b8e4f8d9c91.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1500,
    height: 1226,
  } satisfies TemplateAsset,
  homes: {
    uuid: "8b2a866d-3558-47f5-b7d9-96ef691b559f",
    key: "images/8b2a866d-3558-47f5-b7d9-96ef691b559f.webp",
    extension: "webp",
    mime: "image/webp",
    width: 5464,
    height: 3640,
  } satisfies TemplateAsset,
  basketball: {
    uuid: "f68b9aeb-43bd-4db1-a662-5a0567219ef6",
    key: "images/f68b9aeb-43bd-4db1-a662-5a0567219ef6.webp",
    extension: "webp",
    mime: "image/webp",
    width: 5185,
    height: 3457,
  } satisfies TemplateAsset,
  convPointingDemoExample: {
    uuid: "f7ebef5b-0ea0-40c1-aef8-fa5e8dab9e4a",
    key: "images/f7ebef5b-0ea0-40c1-aef8-fa5e8dab9e4a.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1536,
    height: 1024,
  } satisfies TemplateAsset,
  manufacturingExample: {
    uuid: "61a5641d-e289-4faa-a098-f5d5d8b38e38",
    key: "images/61a5641d-e289-4faa-a098-f5d5d8b38e38.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1536,
    height: 1024,
  } satisfies TemplateAsset,
  vqaDemoExample: {
    uuid: "18794f9e-a436-470e-be79-e0e7577cc42d",
    key: "images/18794f9e-a436-470e-be79-e0e7577cc42d.webp",
    extension: "webp",
    mime: "image/webp",
    width: 800,
    height: 533,
  } satisfies TemplateAsset,
  inContextLearningExample: {
    uuid: "e96e5fbe-bc76-44a3-93bb-e07d7aad1064",
    key: "images/e96e5fbe-bc76-44a3-93bb-e07d7aad1064.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1536,
    height: 1024,
  } satisfies TemplateAsset,
  inContextLearningExample2: {
    uuid: "ee5f83ea-532d-47c1-a4d6-8f3ca665694b",
    key: "images/ee5f83ea-532d-47c1-a4d6-8f3ca665694b.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1536,
    height: 1022,
  } satisfies TemplateAsset,
  manyObjectPointingExample: {
    uuid: "d2dc78be-bb4b-4a07-8df4-73d08fdf582c",
    key: "images/d2dc78be-bb4b-4a07-8df4-73d08fdf582c.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1536,
    height: 1024,
  } satisfies TemplateAsset,
  dameBuzzerBeater: {
    uuid: "8d3aef9b-5b44-4853-8381-80c24dd24deb",
    key: "images/8d3aef9b-5b44-4853-8381-80c24dd24deb.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1280,
    height: 853,
  } satisfies TemplateAsset,
  findTeaPotExample: {
    uuid: "5ce350d9-243f-4030-bfb1-80cf4735b23a",
    key: "images/5ce350d9-243f-4030-bfb1-80cf4735b23a.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1200,
    height: 824,
  } satisfies TemplateAsset,
  cakeMixerExample: {
    uuid: "30196036-96d7-463e-86f4-6d79073ba798",
    key: "images/30196036-96d7-463e-86f4-6d79073ba798.webp",
    extension: "webp",
    mime: "image/webp",
    width: 920,
    height: 920,
  } satisfies TemplateAsset,
  solarInspectionExample: {
    uuid: "500d60d1-81c3-4331-ad7d-803d18dbbefe",
    key: "images/500d60d1-81c3-4331-ad7d-803d18dbbefe.webp",
    extension: "webp",
    mime: "image/webp",
    width: 640,
    height: 480,
  } satisfies TemplateAsset,
  groceryPricingExample: {
    uuid: "a5975d96-8970-4300-bdc2-3601dbb4af35",
    key: "images/a5975d96-8970-4300-bdc2-3601dbb4af35.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1536,
    height: 1536,
  } satisfies TemplateAsset,
  ppeDetectionExample: {
    uuid: "02bb5974-8abd-4423-a536-3bca8971da59",
    key: "images/02bb5974-8abd-4423-a536-3bca8971da59.webp",
    extension: "webp",
    mime: "image/webp",
    width: 640,
    height: 756,
  } satisfies TemplateAsset,
  weeds: {
    uuid: "1aaae817-d8bd-4cfa-99bb-ce682af14f7d",
    key: "images/1aaae817-d8bd-4cfa-99bb-ce682af14f7d.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1222,
    height: 1636,
  } satisfies TemplateAsset,
  fruit: {
    uuid: "b2ce1dd0-fe18-4fe0-ac56-f54dcd39f237",
    key: "images/b2ce1dd0-fe18-4fe0-ac56-f54dcd39f237.webp",
    extension: "webp",
    mime: "image/webp",
    width: 900,
    height: 602,
  } satisfies TemplateAsset,
  discordScreenshot: {
    uuid: "7b785047-ee81-4b56-aade-9ca2f96f5ec6",
    key: "images/7b785047-ee81-4b56-aade-9ca2f96f5ec6.webp",
    extension: "webp",
    mime: "image/webp",
    width: 3648,
    height: 2226,
  } satisfies TemplateAsset,
  iphoneScreenshot: {
    uuid: "01119a46-f8d1-4704-90d2-47a3c71ddcba",
    key: "images/01119a46-f8d1-4704-90d2-47a3c71ddcba.webp",
    extension: "webp",
    mime: "image/webp",
    width: 640,
    height: 1292,
  } satisfies TemplateAsset,
  clocksExample: {
    uuid: "a5b1fba0-39fa-45b0-a9f1-8f4ef555a88b",
    key: "images/a5b1fba0-39fa-45b0-a9f1-8f4ef555a88b.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1000,
    height: 575,
  } satisfies TemplateAsset,
  licensePlateExample: {
    uuid: "4676df51-ea18-49fd-9193-1c1f19c6af23",
    key: "images/4676df51-ea18-49fd-9193-1c1f19c6af23.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1440,
    height: 1088,
  } satisfies TemplateAsset,
  parkingLotExample: {
    uuid: "8b2623d6-d974-4c86-9d7f-99e43477f162",
    key: "images/8b2623d6-d974-4c86-9d7f-99e43477f162.webp",
    extension: "webp",
    mime: "image/webp",
    width: 3000,
    height: 2000,
  } satisfies TemplateAsset,
  rentalAgreementExample: {
    uuid: "cd0b4f24-a0b0-40b1-819d-a8340ba77db1",
    key: "images/cd0b4f24-a0b0-40b1-819d-a8340ba77db1.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1622,
    height: 1912,
  } satisfies TemplateAsset,
  powerPoleWiresExample: {
    uuid: "f36df691-c5f3-4972-83d4-2f69c725e429",
    key: "images/f36df691-c5f3-4972-83d4-2f69c725e429.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1214,
    height: 810,
  } satisfies TemplateAsset,
  deskFlatLayExample: {
    uuid: "a98b0531-eb21-4f1c-a0d4-e4535c8a44cc",
    key: "images/a98b0531-eb21-4f1c-a0d4-e4535c8a44cc.webp",
    extension: "webp",
    mime: "image/webp",
    width: 3840,
    height: 2560,
  } satisfies TemplateAsset,
  emptyParkingSpotsExample: {
    uuid: "74aaf74a-e004-49d0-a073-3984b47a789b",
    key: "images/74aaf74a-e004-49d0-a073-3984b47a789b.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1200,
    height: 628,
  } satisfies TemplateAsset,
  drivingPovExample: {
    uuid: "e307a666-b777-418d-a91d-45fcf2fb5be9",
    key: "images/e307a666-b777-418d-a91d-45fcf2fb5be9.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1280,
    height: 720,
  } satisfies TemplateAsset,
  forkliftWarehouseExample: {
    uuid: "c5f3baf3-923b-4529-a9ba-ec143c56eff7",
    key: "images/c5f3baf3-923b-4529-a9ba-ec143c56eff7.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1195,
    height: 896,
  } satisfies TemplateAsset,
  climbExample: {
    uuid: "ec998b21-19c6-4c72-907a-cfda592e664a",
    key: "images/ec998b21-19c6-4c72-907a-cfda592e664a.webp",
    extension: "webp",
    mime: "image/webp",
    width: 3840,
    height: 2560,
  } satisfies TemplateAsset,
  oaklandFreewayExample: {
    uuid: "edd98439-4ab0-4d19-9116-c8aa9356a927",
    key: "images/edd98439-4ab0-4d19-9116-c8aa9356a927.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1500,
    height: 1000,
  } satisfies TemplateAsset,
  egocentricKettlePourExample: {
    uuid: "18743765-ae7c-490c-87cb-d3cd179ce3f2",
    key: "images/18743765-ae7c-490c-87cb-d3cd179ce3f2.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1024,
    height: 364,
  } satisfies TemplateAsset,
  brisbaneAirportAerialExample: {
    uuid: "c3e8ca75-23ac-436a-9aa8-cc7d3f6eb013",
    key: "images/c3e8ca75-23ac-436a-9aa8-cc7d3f6eb013.webp",
    extension: "webp",
    mime: "image/webp",
    width: 3840,
    height: 2227,
  } satisfies TemplateAsset,
  paradiseFireAerialExample: {
    uuid: "dd08d37c-0124-448b-9ef8-bf6f0c10e5b7",
    key: "images/dd08d37c-0124-448b-9ef8-bf6f0c10e5b7.webp",
    extension: "webp",
    mime: "image/webp",
    width: 2181,
    height: 2376,
  } satisfies TemplateAsset,
  wildlifePtarmiganExample: {
    uuid: "c8716d68-04c0-439e-bcb0-6cc3c4c54924",
    key: "images/c8716d68-04c0-439e-bcb0-6cc3c4c54924.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1088,
    height: 1440,
  } satisfies TemplateAsset,
  wildlifeSnakeExample: {
    uuid: "94bb928c-7bb7-4588-a5b2-62a9ece89af9",
    key: "images/94bb928c-7bb7-4588-a5b2-62a9ece89af9.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1088,
    height: 1440,
  } satisfies TemplateAsset,

  // Video example posters and clips. Drop the matching .webp poster into
  // infra/localstack/init/ready.d/template-images/ and the .mp4 into
  // infra/localstack/init/ready.d/template-videos/ to seed the local CDN.
  roboticsArmVideoPoster: {
    uuid: "a419c511-1c5f-4b5e-834c-d03291128464",
    key: "images/a419c511-1c5f-4b5e-834c-d03291128464.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1280,
    height: 720,
  } satisfies TemplateAsset,
  roboticsArmVideo: {
    uuid: "ae24dc4e-c52f-4889-9a6c-188b2a2c6bf8",
    key: "videos/ae24dc4e-c52f-4889-9a6c-188b2a2c6bf8.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 1280,
    height: 720,
  } satisfies TemplateAsset,
  factoryFloorVideoPoster: {
    uuid: "11e621cf-171b-4fea-8fb6-872923f8cf52",
    key: "images/11e621cf-171b-4fea-8fb6-872923f8cf52.webp",
    extension: "webp",
    mime: "image/webp",
    width: 174,
    height: 266,
  } satisfies TemplateAsset,
  factoryFloorVideo: {
    uuid: "8a439cab-072e-43ce-a10a-34a67aa27a56",
    key: "videos/8a439cab-072e-43ce-a10a-34a67aa27a56.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 174,
    height: 266,
  } satisfies TemplateAsset,
  sportsReplayVideoPoster: {
    uuid: "57c25455-5852-4ab5-a090-e33d89af0f61",
    key: "images/57c25455-5852-4ab5-a090-e33d89af0f61.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1280,
    height: 720,
  } satisfies TemplateAsset,
  sportsReplayVideo: {
    uuid: "f95814c6-fb53-4fdb-89e7-25919cd8a4b6",
    key: "videos/f95814c6-fb53-4fdb-89e7-25919cd8a4b6.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 1280,
    height: 720,
  } satisfies TemplateAsset,
  cookingVideoPoster: {
    uuid: "69bb819a-dcfd-4ee4-be93-18336ef72921",
    key: "images/69bb819a-dcfd-4ee4-be93-18336ef72921.webp",
    extension: "webp",
    mime: "image/webp",
    width: 640,
    height: 360,
  } satisfies TemplateAsset,
  cookingVideo: {
    uuid: "e17a9d2f-0691-4bb9-a9cb-9bfaf0f450e3",
    key: "videos/e17a9d2f-0691-4bb9-a9cb-9bfaf0f450e3.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 640,
    height: 360,
  } satisfies TemplateAsset,
  soccerVideoPoster: {
    uuid: "60a1fdd2-b11b-4e3b-a956-962c340ca70b",
    key: "images/60a1fdd2-b11b-4e3b-a956-962c340ca70b.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1920,
    height: 1080,
  } satisfies TemplateAsset,
  soccerVideo: {
    uuid: "77fb7a93-f5f4-4460-beaf-4459efa8551a",
    key: "videos/77fb7a93-f5f4-4460-beaf-4459efa8551a.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 1920,
    height: 1080,
  } satisfies TemplateAsset,
  javelinVideoPoster: {
    uuid: "60501f18-c75d-4353-9d1f-4e6064d392ec",
    key: "images/60501f18-c75d-4353-9d1f-4e6064d392ec.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1920,
    height: 1080,
  } satisfies TemplateAsset,
  javelinVideo: {
    uuid: "5206fdaf-cf3d-4fe2-810d-0ad77dfe863d",
    key: "videos/5206fdaf-cf3d-4fe2-810d-0ad77dfe863d.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 1920,
    height: 1080,
  } satisfies TemplateAsset,
  humanoidVideoPoster: {
    uuid: "a46095f4-c689-44c1-9988-0f67302c58f8",
    key: "images/a46095f4-c689-44c1-9988-0f67302c58f8.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1920,
    height: 1080,
  } satisfies TemplateAsset,
  humanoidVideo: {
    uuid: "192d5806-0450-45c3-b62a-cd3303e50765",
    key: "videos/192d5806-0450-45c3-b62a-cd3303e50765.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 1920,
    height: 1080,
  } satisfies TemplateAsset,
  golfSwing1Poster: {
    uuid: "ebc10577-ddc7-4ba6-9665-25f159994bd5",
    key: "images/ebc10577-ddc7-4ba6-9665-25f159994bd5.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1168,
    height: 1080,
  } satisfies TemplateAsset,
  golfSwing1Video: {
    uuid: "981aaa3a-fb0f-4031-911d-fc189f4d83a2",
    key: "videos/981aaa3a-fb0f-4031-911d-fc189f4d83a2.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 1168,
    height: 1080,
  } satisfies TemplateAsset,
  golfSwing2Poster: {
    uuid: "9b1f5024-5d36-4ad4-bc56-992969a3593b",
    key: "images/9b1f5024-5d36-4ad4-bc56-992969a3593b.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1080,
    height: 1080,
  } satisfies TemplateAsset,
  golfSwing2Video: {
    uuid: "51262980-f570-48a9-ab15-4bc4f6fa1819",
    key: "videos/51262980-f570-48a9-ab15-4bc4f6fa1819.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 1080,
    height: 1080,
  } satisfies TemplateAsset,
  jumpShotPoster: {
    uuid: "b7a06e35-2e74-41af-b0b1-6b3d9bdee1bf",
    key: "images/b7a06e35-2e74-41af-b0b1-6b3d9bdee1bf.webp",
    extension: "webp",
    mime: "image/webp",
    width: 640,
    height: 360,
  } satisfies TemplateAsset,
  jumpShotVideo: {
    uuid: "bd741416-3c70-422e-b045-d22dc02b814d",
    key: "videos/bd741416-3c70-422e-b045-d22dc02b814d.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 640,
    height: 360,
  } satisfies TemplateAsset,
  cerealItem: {
    uuid: "ee735a38-a0f4-4fdc-887e-01e2537e25e4",
    key: "images/ee735a38-a0f4-4fdc-887e-01e2537e25e4.webp",
    extension: "webp",
    mime: "image/webp",
    width: 500,
    height: 500,
  } satisfies TemplateAsset,
  groceryStoreVideoPoster: {
    uuid: "20283b6e-3102-4b68-8dfd-dae965724b3d",
    key: "images/20283b6e-3102-4b68-8dfd-dae965724b3d.webp",
    extension: "webp",
    mime: "image/webp",
    width: 640,
    height: 360,
  } satisfies TemplateAsset,
  groceryStoreVideo: {
    uuid: "115e2a0f-53a2-4fbf-842e-f1dc47a52703",
    key: "videos/115e2a0f-53a2-4fbf-842e-f1dc47a52703.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 640,
    height: 360,
  } satisfies TemplateAsset,
  aerialViewExample: {
    uuid: "217e1f6a-4671-4d08-83e9-b95a313fd0d0",
    key: "images/217e1f6a-4671-4d08-83e9-b95a313fd0d0.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1664,
    height: 928,
  } satisfies TemplateAsset,
  buildingFireVideoPoster: {
    uuid: "40be1219-3d35-4539-90ee-5110f1dc8cb5",
    key: "images/40be1219-3d35-4539-90ee-5110f1dc8cb5.webp",
    extension: "webp",
    mime: "image/webp",
    width: 1884,
    height: 1000,
  } satisfies TemplateAsset,
  buildingFireVideo: {
    uuid: "7ac0aa28-3a7a-43ac-b57e-86e910610f9f",
    key: "videos/7ac0aa28-3a7a-43ac-b57e-86e910610f9f.mp4",
    extension: "mp4",
    mime: "video/mp4",
    width: 1884,
    height: 1000,
  } satisfies TemplateAsset,
} as const;
